import { createTypedOutlet } from "src/router";

import type { ElementOf } from "ts-essentials";
import type { SyncQuery, SyncRunQuery } from "src/graphql";

export type PartnerSyncRunOutletContext = {
  sync: ElementOf<SyncQuery["syncs"]>;
  syncRequest: NonNullable<SyncRunQuery["sync_requests_by_pk"]>;
};

const {
  OutletProvider: PartnerSyncRunOutlet,
  useContext: usePartnerSyncRunOutletContext,
  useOptionalContext: usePartnerSyncRunOutletContextIfAvailable,
} = createTypedOutlet<PartnerSyncRunOutletContext>("PartnerSyncRun");

export {
  PartnerSyncRunOutlet,
  usePartnerSyncRunOutletContext,
  usePartnerSyncRunOutletContextIfAvailable,
};
